<template>
    <div v-if="menu" class="menu-container">
        <el-menu unique-opened>
            <el-sub-menu v-for="parentItem, parentIndex in menu" :index="parentIndex + ''" :key="parentIndex">
                <template #title>
                    <el-icon>
                        <Location />
                    </el-icon>
                    <span>{{ parentItem.label }}</span>
                </template>
                <el-menu-item v-for="subItem, subIndex in parentItem.children" :index="parentIndex + '-' + subIndex"
                    :key="subIndex" @click="handleClickMenuItem(subItem)">
                    {{ subItem.label }}
                </el-menu-item>
            </el-sub-menu>
        </el-menu>
    </div>
</template>

<script>
import { Location } from '@element-plus/icons-vue';
export default {
    props: ['menu'],
    components: {
        Location
    },
    data() {
        return {

        }
    },
    methods: {
        handleClickMenuItem(item) {
            this.$emit('onMenuItemClick', item)
        }
    }
}
</script>

<style scoped lang="less">
</style>